export default __webpack_public_path__ + "static/media/8.163a2f59.jpg";